<app-header></app-header>
<div class="principal-container">
  <div class="second-container">
    <h1 class="principal-title">Contáctanos</h1>
    <p class="descripcion">
      Para cualquier duda o sugerencia, no dude en ponerse en contacto con
      nosotros. Estaremos encantados de atenderle
    </p>
  </div>
  <div class="card-contact">
    <mat-card>
      <div class="row">
        <div class="col-md-5">
          <div class="left-side">
            <p class="email">
              <mat-icon class="icon-s-l">mail_outline</mat-icon>
              kalediolabco@gmail.com
            </p>
            <p class="country">
              <mat-icon class="icon-s-l">pin_drop</mat-icon>
              Colombia
            </p>
            <p class="phone">
              <mat-icon class="icon-s-l">local_phone</mat-icon>
              +57 321 748 3287
            </p>
          </div>
        </div>
        <div class="col-md-7">
          <div class="right-side">
            <div class="right-side-container">
              <form [formGroup]="contactForm">
                <!-- Inicio 2 Campos juntos -->
                <mat-form-field appearance="legacy" class="names">
                  <mat-label>Nombre</mat-label>
                  <mat-icon matPrefix>panorama_fish_eye</mat-icon>
                  <input matInput type="text" formControlName="nombre" />
                </mat-form-field>
                <mat-form-field appearance="legacy" class="lastnames">
                  <mat-label>Apellidos</mat-label>
                  <mat-icon matPrefix>panorama_fish_eye</mat-icon>
                  <input matInput type="text" formControlName="apellido" />
                </mat-form-field>
                <!-- Fin 2 Campos juntos -->

                <mat-form-field appearance="legacy" class="phone">
                  <mat-label>Teléfono</mat-label>
                  <mat-icon matPrefix>panorama_fish_eye</mat-icon>
                  <input matInput type="tel" formControlName="telefono" />
                </mat-form-field>
                <mat-form-field appearance="legacy" class="email">
                  <mat-label>Correo eletrónico</mat-label>
                  <mat-icon matPrefix>panorama_fish_eye</mat-icon>
                  <input matInput type="text" formControlName="correo" />
                </mat-form-field>

                <mat-form-field appearance="legacy" class="message">
                  <mat-label>Mensaje</mat-label>
                  <mat-icon matPrefix>panorama_fish_eye</mat-icon>
                  <textarea
                    matInput
                    name=""
                    id=""
                    formControlName="mensaje"
                  ></textarea>
                </mat-form-field>
                <div class="check-container">
                  <mat-checkbox formControlName="checkPolitics"></mat-checkbox>
                </div>
                <p
                  class="checkPolitics"
                  style="font-family: 'Montserrat' !important;"
                >
                  Acepto la política de tratamiento de datos y los términos y
                  condiciones de uso
                </p>
              </form>
            </div>
            <button
              (click)="sendEmail(contactForm.value)"
              [disabled]="
                !contactForm.valid && !contactForm.value.checkPolitics
              "
              mat-button
              class="btn btn-enviar"
            >
              Enviar
            </button>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
</div>
